import { isAfter, isBefore } from 'date-fns';

const handleAfterTicketSaleEndsOrSellsOut = ({
  entity,
  entityKey,
  allEntities,
  checkSoldOutFunc,
  now,
}) => {
  if (!entity[entityKey]) return false;

  const reference = allEntities.find(tt => tt._id === entity[entityKey]);
  if (!reference || reference.status !== 'enabled') return false;

  const referencedBehavior = reference.availabilityBehavior || 'always_available';

  // Check if either trigger condition is met
  let triggerConditionMet = false;

  // Condition 1: Referenced ticket sale has ended
  if (referencedBehavior !== 'always_available') {
    const behaviorsWithSaleEndOn = [
      'until_event_starts',
      'date_time_based',
      'after_ticket_sale_ends',
      'after_ticket_ends_or_sold_out',
    ];

    if (behaviorsWithSaleEndOn.includes(referencedBehavior)) {
      const saleStartOn = reference.saleEndOn ? new Date(reference.saleEndOn) : null;

      if (saleStartOn && isAfter(now, saleStartOn)) {
        triggerConditionMet = true;
      }
    }
  }

  // Condition 2: Referenced ticket is sold out
  if (!triggerConditionMet) {
    const isSoldOut = checkSoldOutFunc(reference);

    if (isSoldOut) {
      triggerConditionMet = true;
    }
  }

  // If neither trigger condition is met, ticket is not on sale
  if (!triggerConditionMet) return false;

  // Check our own sale window
  const ourSaleEndOn = entity.saleEndOn ? new Date(entity.saleEndOn) : null;
  const isBeforeOurEnd = ourSaleEndOn ? isBefore(now, ourSaleEndOn) : true;

  return isBeforeOurEnd;
};

export default handleAfterTicketSaleEndsOrSellsOut;
